import { render, staticRenderFns } from "./DottedCard.vue?vue&type=template&id=000004ce&scoped=true"
import script from "./DottedCard.vue?vue&type=script&lang=js"
export * from "./DottedCard.vue?vue&type=script&lang=js"
import style0 from "./DottedCard.vue?vue&type=style&index=0&id=000004ce&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000004ce",
  null
  
)

export default component.exports